module.exports = __webpack_public_path__ + "img/banker-purple_1920.722f02b3.png";